import { render, staticRenderFns } from "./CoursewareCompanionBox.vue?vue&type=template&id=0d434dba&"
import script from "./CoursewareCompanionBox.vue?vue&type=script&lang=js&"
export * from "./CoursewareCompanionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports